import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ContactService } from 'src/app/services/contact.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
@Component({
  selector: 'app-esim-contact-info-form',
  templateUrl: './esim-contact-info-form.component.html',
  styleUrls: ['./esim-contact-info-form.component.scss']
})
export class EsimContactInfoFormComponent implements OnInit {
  ContactForm: any;
  userInfo: any;
  userLoggedIn: boolean = false;
  ENV: string;
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();
  @Input() ContainsVisitorLine: any;
  constructor(
    private FB: FormBuilder,
    private SS: SubjectService,
    private US: UserInfoService,
    private CNS: ContactService,
    private UTS: UtilitiesService
  ) {
    
   }

  ngOnInit(): void {
    if(this.ContainsVisitorLine){
      this.ContactForm = this.FB.group({
        email: ['', [Validators.required, Validators.email]],
        mobileNumber: [
          '',
          [
            Validators.pattern("[0-9+]*"),
            Validators.minLength(10),
            Validators.maxLength(16),
          ],
        ],
      }); 
    }else{
      this.ContactForm = this.FB.group({
        email: ['', [Validators.required, Validators.email]],
      });
    }
    this.SS.refreshContactInfo.subscribe((res) => {
      if (res) {
        this.userInfo = { ...this.userInfo, ...res };
        this.UTS.setUserInfo(this.userInfo);
      }
    });
    this.getUserInfo();
  }
  getUserInfo() {
    this.CNS.getUserInfo().subscribe(
      (r: any) => {
        if (r) {
          this.userInfo = r;
          this.getPersonalInfo();
          this.userLoggedIn = true;
          const accessToken = localStorage.getItem('AccessToken');
          this.ENV = localStorage.getItem('ENV');
        }
      },
      (e) => {
        this.userInfo = null;
        this.userLoggedIn = false;
        this.getPersonalInfo();
      }
    );
  }
  getPersonalInfo() {
    setTimeout(()=>{
      this.US.getPersonalInfo().subscribe((r) => {
        if (Object.keys(r).length > 0) {
          this.userInfo = { ...this.userInfo, ...r };
        }
        if(this.userInfo && this.userInfo?.email){
          this.ContactForm.controls.email.setValue(this.userInfo?.email);
        }
        if(this.ContainsVisitorLine){
          if(this.userInfo && this.userInfo?.mobileNumber){
            this.ContactForm.controls.mobileNumber.setValue(this.userInfo?.mobileNumber);
          }
        }
      })
    },500)
  }

  get errorControl() {
    return this.ContactForm.controls;
  }
  contactFormSubmitted() {
    if (this.ContactForm.valid) {
      this.formSubmit.emit(this.ContactForm);
    }
  }
}
